import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { currentJWT } from 'lib/AuthUtils';
import { fetchUserOrganizationIds } from 'features/me/meSlice';
import { AppDispatch } from 'components/store';
import RecordNotFound from 'lib/errors/RecordNotFound';
import { Auth } from 'aws-amplify';
import { isErrorInstanceOf } from './Utils';


const withAuth = (WrappedComponent: any) => {
  const WrapperComponent = (props: any) => {
    const router = useRouter();
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
      const checkAuth = async () => {
        let jwt: string;
        try {
          jwt = await currentJWT();
          //throw new RecordNotFound("This is a test");
          await dispatch(fetchUserOrganizationIds(jwt)).unwrap();
        } catch (err) {
          console.error("withAuth Error:");
          console.error(RecordNotFound.error_name);
          console.error(err);
          

          if(jwt) { 
            console.error("Do some setup here");
            router.push('/signup', undefined, {shallow: true});
          } else {
            //
            //debugger;
            //Prevent infinite loop
            Auth.signOut();
            router.push('/', undefined, {shallow: true});
          }
        }
      };

      checkAuth();
    }, [router]);

    return (
      <WrappedComponent {...props} />
    );
  };

  return WrapperComponent;
};

export default withAuth;